import Pusher from 'pusher-js';
import axios from 'axios';
import store from "@/store";

const pusher = new Pusher(`${process.env.VUE_APP_PUSHER_KEY}`, {
    encrypted: true,
    cluster: `${process.env.VUE_APP_PUSHER_CLUSTER}`,
    authorizer: function(channel, options){
        return {
            authorize: function(socketId, callback){

                const formData = new FormData();
                formData.append("channel_name", channel.name);
                formData.append("socket_id", socketId);
                formData.append("user_id", store.state.user_id + "");

                axios({ method: "POST",
                    url: `${process.env.VUE_APP_API_URL}/Chat/Auth`,
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        'Authorization': 'Bearer ' + store.state.authToken
                    }})
                    .then(res => {
                        callback(null, res.data);
                    })
                    .catch(function (err) {
                        callback(new Error(`Error calling auth endpoint: ${err}`), {auth: ""});
                    });
        }};
    }
});

export default pusher;